module.exports = __webpack_public_path__ + "static/3-ce92b87898ceb6f25764d3de764ddbae.jpg";